export class OportunidadStagePayload {
  stage: string = "";
  nota?: string;  // si se provee, se agrega también como evento "note"
}
